package com.partejar.app.core.security

import androidx.compose.runtime.Composable

enum class BiometricAvailability {
    AVAILABLE,
    NOT_CONFIGURED,
    UNAVAILABLE,
    UNSUPPORTED
}

sealed interface BiometricAuthenticationResult {
    data object Success : BiometricAuthenticationResult
    data object Cancelled : BiometricAuthenticationResult
    data object Failed : BiometricAuthenticationResult
    data object Unavailable : BiometricAuthenticationResult
}

interface BiometricAuthenticator {
    fun availability(): BiometricAvailability
    suspend fun authenticate(
        title: String = "Desbloquear Partejar",
        reason: String = "Confirme sua identidade para continuar."
    ): BiometricAuthenticationResult
}

@Composable
expect fun rememberBiometricAuthenticator(): BiometricAuthenticator
